import general from '@app/locales/translates/general';
import breadcrumb from '@app/locales/translates/breadcrumb';
import BrandCreateBrand from '@app/locales/translates/brand/createbrand';
import ProjectCreateProject from '@app/locales/translates/project/createproject';
import Group from '@app/locales/translates/project/projectSetting/group';
import AccountSignin from '@app/locales/translates/accounts/signin';
import AccountSchema from '@app/locales/translates/accounts/schema';
import AccountRegister from '@app/locales/translates/accounts/register';
import AccountOtp from '@app/locales/translates/accounts/otp';
import AccountTnC from '@app/locales/translates/accounts/tandc';
import AccountResetPassword from '@app/locales/translates/accounts/resetpassword';
import BrandSelect from '@app/locales/translates/brand/select';
import EndUser from '../translates/users/endUser';
import ProjectSelect from '@app/locales/translates/project/select';
import UserProfile from '@app/locales/translates/users/profile';
import PermissionList from '@app/locales/translates/permission/listpermission';
import Winnonie from '@app/locales/translates/winnonie';

const translateEn = {
  general: general.EN,
  breadcrumb: breadcrumb.EN,
  menu: {
    overview_dashboard: 'Home',
    brand: 'Brand',
    project: 'Projects',
    sign_out: 'Sign out',
    access: 'Access',
  },
  band: {
    select: BrandSelect.EN,
  },
  project: {
    select: ProjectSelect.EN,
    createproject: ProjectCreateProject.EN,
    project_setting: {
      group: Group.EN,
    },
  },
  accounts: {
    signin: AccountSignin.EN,
    schema: AccountSchema.EN,
    register: AccountRegister.EN,
    otp: AccountOtp.EN,
    tandc: AccountTnC.EN,
    resetpassword: AccountResetPassword.EN,
  },
  brand: {
    createbrand: BrandCreateBrand.EN,
  },
  user: {
    endUser: EndUser.EN,
    profile: UserProfile.EN,
  },
  permission: {
    listpermission: PermissionList.EN,
  },
  winnonie: Winnonie.EN,
};

export default translateEn;
